import { takeLatest, all, call, put, select } from "redux-saga/effects";
import {
  allReservaCarro,
  updateReservaCarro,
  filterReservaCarro,
} from "./actions";
import types from "./types";
import { api } from "../../../services/api";
import consts from "../../../consts";
import { useSelector } from "react-redux";

export function* AllReservaCarros() {
  const { form, reservations, reservaCarros } = yield select(
    (state) => state.reserva
  );
  const { auth } = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));

    const { data: res } = yield call(
      api.get,
      `/reservations/availability/${reservations.start_date?reservations.start_date : Date.now() }/${reservations.end_date}`,
      {
        headers: {
          Authorization: `Bearer ${
            auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
          }`,
        },
      }
    );
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    console.log(res);
    yield put(updateReservaCarro({ carrosDisponivel: res }));
  } catch (error) {
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* AllReservadosClienteCarros() {
  const { cliente} = yield select((state) => state.cliente);
  const { form, reservations, reservaCarrosCliente } = yield select(
    (state) => state.reserva
  );
  const { auth } = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));

    const { data: res } = yield call(
      api.get,
      `/reservations/users/${sessionStorage.getItem("id")}/${reservations.start_date?`${reservations.start_date}/${reservations.end_date?reservations.end_date:""}`:""}`,
      {
        headers: {
          Authorization: `Bearer ${
            auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
          }`,
        },
      }
    );
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    console.log(res);
    yield put(updateReservaCarro({ reservaCarrosCliente: res }));
  } catch (error) {
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* filterReservaCarros() {
  const { form, cliente } = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.post, `/clientes/filter`, {
      filters: { email: cliente.email, status: "A" },
    });
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    if (res.clientes.length > 0) {
      yield put(
        updateReservaCarro({
          cliente: res.clientes[0],
          form: { ...form, filtering: false, disable: false },
        })
      );
    } else {
      yield put(updateReservaCarro({ form: { ...form, disable: false } }));
    }
  } catch (error) {
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addVehicleReservation() {
  const {
    form,
    reservations,
    carrosDisponivel,
    vehicles,
    users,
    users_licenses,
    carros_Alugados,
  } = yield select((state) => state.reserva);
  const { cliente , auth } = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));
    const clientID=  sessionStorage.getItem("id");
    const { data: res } = yield call(api.post, `/reservations`, 
    {
        
        start_date: reservations.start_date,
        end_date: reservations.end_date,
        vehicles_id: vehicles.id,
        users_id:clientID,
        user_observations: reservations.user_observations,
      },
      {
        headers: {
          Authorization: `Bearer ${
            auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
          }`,
        },
      }
    );
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);
      
      return false;
    }
    
    yield put(updateReservaCarro({ reservaCarrosCliente: res }));
  } catch (error) {

    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* canselarReserva() {
  const {
    form,
    reservations,
    carrosDisponivel,
    vehicles,
    users,
    users_licenses,
    carros_Alugados,
  } = yield select((state) => state.reserva);
  const { auth } = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.delete, `/reservations/${vehicles.id}`,{
        headers: {
          Authorization: `Bearer ${
            auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
          }`,
        },
      }
    );
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(updateReservaCarro({ reservaCarrosCliente: res }));
  } catch (error) {
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* allCarros() {
  const { form, auth ,carros} = yield select((state) => state.cliente);
  try {
    yield put(updateReservaCarro({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/vehicles`,{
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });

    console.log(res)
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    
    yield put(updateReservaCarro({ carros: res }));
 
  } catch (error) {
    yield put(updateReservaCarro({ form: { ...form, filtering: false } }));
    alert(error.message);
  
  }
}






export default all([
  takeLatest(types.ALL_HORARIOS_RESERVA, AllReservaCarros),
  takeLatest(types.ALL_CARROS, allCarros),
  takeLatest(types.ALL_CARROS_CLIENTE_RESERVA, AllReservadosClienteCarros),
  takeLatest(types.FILTER_HORARIO_RESERVA, filterReservaCarros),
  takeLatest(types.ADD_HORARIO_RESERVATION, addVehicleReservation),
  takeLatest(types.REMOVE_HORARIO_RESERVA, canselarReserva),
]);
